import type { BaseTimePickerProps } from './BaseTimePicker';
import type { DateTimeFilter } from '~/presentation/ui';

import {
  CompareDateTimePickerAlias,
  DATE_TIME_COMPARISON_FILTERS,
  getDateRangeTitle,
} from '~/presentation/ui';
import { useCompareDateTimePicker } from '../hooks/useCompareDateTimePicker';
import { BaseTimePicker } from './BaseTimePicker';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

interface CompareTimePickerProps extends Pick<
  BaseTimePickerProps,
  'rangeAddition' | 'popoverProps'
> {}
export const CompareTimePicker: React.FC<CompareTimePickerProps> = (props) => {
  const { rangeAddition, popoverProps } = props;

  const initialPicked = rangeAddition?.initialPicked;
  const dateTimeFilters = DATE_TIME_COMPARISON_FILTERS;
  const ranges: DateTimeFilter[] = [...dateTimeFilters, ...(rangeAddition?.rangers || [])];

  const { t } = useTranslation();
  const { compareDateTimePicked } = useCompareDateTimePicker({ ranges, initialPicked });

  const buttonValue = useMemo(() => {
    if (compareDateTimePicked.alias === CompareDateTimePickerAlias.NO_COMPARISON) {
      return t('No comparison');
    }

    return t('Compare to: {{value}}', {
      value: getDateRangeTitle(compareDateTimePicked.since, compareDateTimePicked.until),
    });
  }, [compareDateTimePicked, t]);

  return (
    <BaseTimePicker
      dateTimeFilters={dateTimeFilters}
      rangeAddition={rangeAddition}
      popoverProps={popoverProps}
      isCompare
      buttonValue={buttonValue}
    />
  );
};
